/**
 * Filtro para poner la primera letra de la frase en mayúsuculas, o de cada palabra, etc.
 * Fuente: https://github.com/Puigcerber/angular-capitalize-filter
 * @returns {Function}
 */
export default function CapitalizeFilter() {
    return function (input, format) {
        if (!input) {
            return input;
        }
        format = format || 'first';
        if (format === 'first') {
            // Capitalize the first letter of a sentence
            return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
        } else {
            var words = input.split(' ');
            var result = [];
            words.forEach(function (word) {
                if (word.length === 2 && format === 'team') {
                    // Uppercase team abbreviations like FC, CD, SD
                    result.push(word.toUpperCase());
                } else {
                    result.push(word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
                }
            });
            return result.join(' ');
        }
    };
}